/* unplugin-vue-components disabled */import { render } from "./BindWechatAccount.vue?vue&type=template&id=dfdfb9e6&ts=true"
import script from "./BindWechatAccount.vue?vue&type=script&lang=ts"
export * from "./BindWechatAccount.vue?vue&type=script&lang=ts"

import "./BindWechatAccount.vue?vue&type=style&index=0&id=dfdfb9e6&lang=scss"

import exportComponent from "/root/workspace/estate-mobile_9SbA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__